import React, { Fragment, useEffect, useContext, useState } from "react";
import { api } from "../../api";
import Header from "../../general/navigation/Header";
import Loading from "../../general/components/Loading.js";
import VisaCitizenshipProcessingTimeRow from "./VisaCitizenshipProcessingTimeRow";
import Select from "react-select";
import { CountryContext } from '../../context/CountryContext';

const VisaCitizenshipProcessingTime = () => {
  // Setup context variable
  const countryState = useContext(CountryContext);

  // Setup state variables
  const [country, setCountry] = useState(null);
  const [countries, setCountries] = useState([]);
  const [citizenshipProcessingTimeMap, setCitizenshipProcessingTimeMap] = useState(null);
  const [filteredCountry, setFilteredCountry] = useState(null);
  const [countryOptions, setCountryOptions] = useState(null);
  const [governmentProcessingData, setGovernmentProcessingData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [setupCalled, setSetupCalled] = useState(false);

  useEffect(() => {
    if (!countryState[0]?.selectedCountry) {
      window.location.replace("/#/");
    } else {
        if(!setupCalled) {
          setupPageData();
          setSetupCalled(true);
        }
        if(country && countries && citizenshipProcessingTimeMap){
          setIsLoading(false);
        } 
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [country,countries,citizenshipProcessingTimeMap]);

  const setupPageData = async () => {
    const selectedCountry = countryState[0]?.selectedCountry;
    const otherCountries = countryState[0]?.countries.filter(
      (countryItem) => countryItem.id !== selectedCountry.id
    );
    setCountry(selectedCountry);
    const countries = await fetchCountries(otherCountries);
    await createCitizenshipProcessingTimesMap(selectedCountry, countries);
    processingTimesCountryList(countries);
  };



  const fetchCountries = async (otherCountries) => {
    const countries = [];
    const notDisclosedId = 0;
    const notDisclosedResponse = await api.get(`/countries/${notDisclosedId}`);
    if (notDisclosedResponse.data) {
      countries.push(notDisclosedResponse.data);
    }
    countries.push(...otherCountries);
    setCountries(countries);
    return countries;
  };

  const createCitizenshipProcessingTimesMap = async (country,countries) => {
    const visaResponse = await api.get(`/visas`);
    const relevantVisas = visaResponse.data.filter(
      (visa) => visa.destinationRegion.id === country.regions[0].id
    );
    let citizenshipProcessingTimeTemporaryMap = new Map();
    for (const country of countries) {
      const countryRegionId = country.regions[0] ? country.regions[0].id : null;
      let visaObject = relevantVisas.filter(
        (visa) => visa.sourceRegion.id === countryRegionId
      )[0];
      citizenshipProcessingTimeTemporaryMap.set(countryRegionId, visaObject);
    }
    setCitizenshipProcessingTimeMap(citizenshipProcessingTimeTemporaryMap);
  };

  /**
   * Filter to show only the country which was selected, unless 'All' was selected, in which case, filter none of the countries.
   * @param {object} event on change in the country select dropdown.
   */
  const handleFilterUpdate = (event) => {
    if (event.value === "All") {
      setFilteredCountry(null);
    } else {
      setFilteredCountry(
        countries.filter((country) => country.id === event.value.id)[0]
      );
    }
  };

  /**
   * Sets the list of countries to appear as options in the dropdown.
   */
  const processingTimesCountryList = (countries) => {
    const countryList = [];
    // Set both value and label of 'All' as a string, so that only the string needs to be compared.
    countryList.push({
      label: "All",
      value: "All",
    });

    for (const countryOption of countries) {
      countryList.push({
        label: countryOption.name,
        value: countryOption,
      });
    }

    setCountryOptions(countryList);
  };

  const saveMultiple = async (visaObject) => {
    await api
      .patch(`/visas/`, visaObject)
      .catch((error) => console.error(error));
    await api
      .post(`/visas/all/`, visaObject)
      .catch((error) => console.error(error));

    setupPageData();
    setGovernmentProcessingData([]);
  };

  return (
    <Fragment>
      <Header
        showClientNavigation={false}
        showImmigrationNavigation={true}
        displayName={country ? country.name : ""}
        link={"/select-country"}
      />
      {isLoading ? (
        <Loading />
      ) : (
          <Fragment>
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <h3 className="gw__section-headings">
                    Citizenship Processing Times
                  </h3>
                </div>
              </div>
              <div className="row">
                <div className="col-12 d-flex justify-content-center mb-4 mt-2">
                  <div className="col-6">
                    <label htmlFor="country-select" className="text-secondary">
                      SELECT COUNTRY
                    </label>
                    <Select
                      options={countryOptions}
                      onChange={(event) => handleFilterUpdate(event)}
                    />
                  </div>
                </div>
              </div>
              <table className="table">
                <thead>
                  <tr>
                    <th scope="col">Citizenship</th>
                    <th scope="col">Visa Status</th>
                    <th scope="col">Processing Time (Weeks)</th>
                    <th scope="col">Premium Processing Time (Weeks)</th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  {filteredCountry ? (
                    <VisaCitizenshipProcessingTimeRow
                      country={filteredCountry}
                      destinationCountry={country}
                      setupPageData={setupPageData}
                      visa={citizenshipProcessingTimeMap.get(filteredCountry.id)}
                      setGovernmentProcessingData={setGovernmentProcessingData}
                    />
                  ) : (
                    countries.map((sourceCountry, index) => {
                      return (
                        <VisaCitizenshipProcessingTimeRow
                          key={index}
                          country={sourceCountry}
                          destinationCountry={country}
                          setupPageData={setupPageData}
                          visa={citizenshipProcessingTimeMap.get(
                            sourceCountry.id
                          )}
                          setGovernmentProcessingData={
                            setGovernmentProcessingData
                          }
                        />
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
            <div>
              <button
                type="button"
                onClick={() => saveMultiple(governmentProcessingData)}
                className="btn btn-primary"
                style={{ position: "fixed", top: "200px", left: "0%" }}
              >
                Save All
              </button>
              {/* <button
              type="button"
              onClick={() =>
                deleteMultiple(visas)
              }
              className="btn btn-danger"
              style={{position:"fixed", top:'270px', left:'0%'}}
              >Delete All</button> */}
              {/* <SaveAllButton visaObject={governmentProcessingData} setupPageData={setupPageData}/> */}
            </div>
          </Fragment>
        )
      };
    </Fragment>
  );
};

export default VisaCitizenshipProcessingTime;
